import { Box, Typography } from "@mui/material";
import AurSvgIcon from "../common/aur-svg-icon/AurSvgIcon";
import {t} from 'i18next';
import {ReactComponent as BackgroundImage} from '../../assests/svg/glow-right.svg';

const WelcomeScreenNoClients = () => {
    return(
        <Box className='welcome-no-client center-align-center-y'>
            <BackgroundImage className="background-image" />
            <Box>
                <Box className='center-align-center-y'>
                    <AurSvgIcon src="images/no_client_bg.svg"/>
                </Box>
                <Box className="welcome-no-client-label">
                    <Typography className="typo-text headline1_size mist-100">
                        {t('welcome.noClientText')}
                    </Typography>
                    <Typography className="typo-text body2_size mist-400">
                        {t('welcome.noClientSubText')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}

export default WelcomeScreenNoClients;